import React from 'react';
import * as MuiIcons from '@mui/icons-material';

function DynamicIcon(props) {
  const { iconName, ...other } = props;
  const Icon = MuiIcons[iconName];

  return <Icon {...other} />;
}

export default DynamicIcon;
